var _g, _g2, _g3, _path, _path2, _circle, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThanku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 248,
    viewBox: "0 0 249 248",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_b_4137_46546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    width: 247.863,
    height: 247.863,
    rx: 123.932,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.06641,
    y: 0.5,
    width: 246.863,
    height: 246.863,
    rx: 123.432,
    stroke: "#E9E9E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_b_4137_46546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8242,
    y: 15.2578,
    width: 217.349,
    height: 217.349,
    rx: 108.674,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3242,
    y: 15.7578,
    width: 216.349,
    height: 216.349,
    rx: 108.174,
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter2_b_4137_46546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.082,
    y: 30.5156,
    width: 186.833,
    height: 186.833,
    rx: 93.4163,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.582,
    y: 32.0156,
    width: 183.833,
    height: 183.833,
    rx: 91.9163,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.115 74.8594H85.1152C82.3538 74.8594 80.1152 77.098 80.1152 79.8594V159.859C80.1152 162.621 82.3538 164.859 85.1152 164.859H150.115C152.877 164.859 155.115 162.621 155.115 159.859V79.8594C155.115 77.098 152.877 74.8594 150.115 74.8594Z",
    stroke: "#0E2B3A",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.615 64.8594V79.8594M132.615 64.8594V79.8594M97.6152 102.359H137.615M97.6152 122.359H127.615M97.6152 142.359H117.615",
    stroke: "#0E2B3A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.116,
    cy: 161.239,
    r: 19.2646,
    fill: "#F4F4F4",
    stroke: "#0E2B3A",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.889 154.851L151.908 167.784L145.344 161.239",
    stroke: "#0E2B3A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4137_46546",
    x: -69.4336,
    y: -70,
    width: 387.863,
    height: 387.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4137_46546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4137_46546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4137_46546",
    x: -54.1758,
    y: -54.7422,
    width: 357.35,
    height: 357.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4137_46546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4137_46546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_4137_46546",
    x: -38.918,
    y: -39.4844,
    width: 326.832,
    height: 326.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4137_46546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4137_46546",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanku);
export default __webpack_public_path__ + "static/media/thanku.ec7ac2c98025d023421b0b07af81c2a8.svg";
export { ForwardRef as ReactComponent };